import { MDBBtn, MDBIcon, MDBScrollspy, MDBScrollspyLink, MDBSelect, MDBTooltip } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useNavigate } from 'react-router-dom';
import SaveChanges from "../../src/components/topviews/saveCancel.js";
import {
  getDeviceOnlineStatusInfo,
  getExistingOnly911Locations,
  getSpesificManualDeviceDetails,
  passWordReset,
  saveManualDeviceDetails,
} from "../apiclients/streamsapi_bridge";
import Body from "../components/body/BodyPage";
import copyIcon from "../components/images/copyurl.svg";
import eye from "../components/images/eye.svg";
import closedEye from "../components/images/eye_closed.svg";
import refresh from "../components/images/refresh.svg";
import MainLinks from "../components/navlinks/MainLinks";
import PopupLoader from "./popups/PopupLoader";
import AddDevices from "./popups/phonesystem/AddDevice";

import {
  MDBAlert,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBCol,
  MDBRow,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";
import { customSearchFn } from "../components/CustomSearchUtil/CustomSearch.js";
function ManualDeviceSettings(props) {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();

  // React Hook form
  const {
    register,
    reset,
    watch,
    formState: { dirtyFields, isDirty, errors },
    handleSubmit,
    setError,
    setValue,
    getValues,
  } = useForm();

  const location = useLocation();
  const combineData = location?.state ? JSON.parse(location.state.device) : {} ;
  const [preDeviceInfo, setPreDeviceInfo] = useState(combineData?.preDeviceInfo || "");
  const [nextDeviceInfo, setNextDeviceInfo] = useState(combineData?.nextDeviceInfo || "");
  const [deviceInfo, setDeviceInfo] = useState(combineData?.selMember || "");
  const [deviceListInfo, setDeviceListInfo] = useState(combineData?.deviceList);
  console.log("deviceListInfo:::" + deviceListInfo);

  const [deviceUUID, setDeviceUUID] = useState(
    location.state
      ? location.state.deviceUUID
        ? location.state.deviceUUID
        : ""
      : ""
  );

  const [basicActive, setBasicActive] = useState("tab1");

  const [deviceData, setDeviceData] = useState({});

  // const [proxyPort, setproxyPort] = useState("7970");
  const [tooltipText, setTooltipText] = useState("Copy");
  const [onlineStatus, setOnlineStatus] = useState(false);
  const [device, setDevice] = useState("");
  const [showCopied, setShowCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // const [outboundproxyServer, setOutboundproxyServer] = useState("sip.streams.us");
  const [isEdited, setEdited] = useState("");
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  const [verticalActive, setVerticalActive] = useState("tab1");

  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }

    setVerticalActive(value);
  };

  const [selectedRegion, setSelectedRegion] = useState("IN");

  const { t, i18n } = useTranslation();

  const [showAddDevicePopup, setShowAddDevicePopup] = useState(false);

  const closePopup = () => {
    setShowAddDevicePopup(false);
  };
  const toggleShow7 = () => setShowAddDevicePopup(!showAddDevicePopup);

  // const firstImage = eye;
  // const secondImage = closedEye;

  const [isFirstImage, setIsFirstImage] = useState(closedEye);

  const toggleImage = () => {
    setIsFirstImage(!isFirstImage);
  };

  const [showDiv, setShowDiv] = useState(false);
  const fetchData = async (device) => {
    let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    let paramjo1 = {};
    paramjo1.siteid = siteid;
    paramjo1.deviceUUid = device ? device : location.state.deviceUUID;
    let saverepData = await getSpesificManualDeviceDetails(siteid, paramjo1);
    if (!saverepData.ok) {
      console.log("Network response was not ok");
      throw new Error("Network response was not ok");
    } else {
      let saverepeMsg = await saverepData.json();
      let manualDeviceData = saverepeMsg.manualDeviceData;
      setDeviceData(manualDeviceData);
      //  setValue(`profile_id`, item);
      console.log("response Data :" + JSON.stringify(manualDeviceData));
      reset(manualDeviceData);
    }
  };

  // const copyToClipboard = (textContent) => {
  //   navigator.clipboard
  //     .writeText(textContent)
  //     .then(() => {
  //       setisCopied(true);
  //       console.log("Ganesh copied sucess ");
  //     })
  //     .catch(() => {
  //       console.log("Ganesh copied failed ");
  //     });
  // };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  const onCloseChanges = () => {
    reset(deviceData);
  };

  const onsaveChanges = (formdata) => {
    try {
      console.log("[ManualDeviceSettings.js] Making server request to submit ");
      if (isDirty) {
        const inputParams = frameParams(formdata);
        updateDeviceDetailsreq(inputParams);
      }
    } catch (e) {
      console.error(
        "[ManualDeviceSettings.js] Error while making server request " + e
      );
    }
  };

  const updateDeviceDetailsreq = async (inputParams) => {
    console.log("[updateDeviceDetailsreq] ");
    let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    console.log("location.state.deviceUUID " + location.state.deviceUUID)
    inputParams.reqid = 32;
    inputParams.siteid = siteid;
    inputParams.device_uuid = location.state.deviceUUID;
    const ServerRequest = await saveManualDeviceDetails(siteid, inputParams);
    if (!ServerRequest.ok) {
      console.log("Network response was not ok");
      // throw new Error("Network response was not ok");
    } else {
      console.log("Api response id success:");
      localStorage.setItem("s_message", "Updated Successful");
      window.location.reload();
      // fetchData();
    }
  };

  const frameParams = (formdata) => {
    console.log(
      "[ManualDeviceSettings.js] frame prams" + JSON.stringify(formdata)
    );
    try {
      var requestParams = {};
      console.log("Dirty Fields :::" + JSON.stringify(dirtyFields));
      Object.keys(dirtyFields).map((key) => {
        if (formdata[key]) {
          requestParams[key] = formdata[key];
        }
      });
      console.log(JSON.stringify(requestParams));
      return requestParams;
    } catch (e) {
      console.log("Error in [ManualDeviceSettings.js][frameParams] :" + e);
    }
  };

  const regeneratePassword = async () => {
    console.log("[ManualDeviceSettings.js][regeneratePassword] :");
    try {
      setShowDiv(true);
      let jo = {};
      let siteId = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      jo.siteid = siteId;
      jo.device_uuid = location.state.deviceUUID;;
      const serverResponse = await passWordReset(siteId, jo);
      if (!serverResponse.ok) {
        setShowDiv(false);
        console.log("Network response was not ok");
        // throw new Error("Network response was not ok");
      } else {
        let saverespData = await serverResponse.json();
        let resData = saverespData.newPasswordInfo;
        console.log("response::::::" + JSON.stringify(resData));
        if (resData.deviceuuid == location.state.deviceUUID) {
          deviceData.password = resData.sippassword;
        }
        setShowDiv(false);
        reset(deviceData);
      }
    } catch (e) {
      console.error("[ManualDeviceSettings.js][regeneratePassword]  :  ");
    }
  };

  const fetchDeviceOnlineStatus = async () => {
    console.log("Making requets to fetch DeviceOnlineStatus ");

    try {
      var paramsJo = {
        deviceUUID: deviceData.deviceuuid,
        userUUId: [deviceData.userUUID],
        userid: deviceData.agentId,
        deviceType: "Manual"
      };
      console.log("praramJO:::::::::" + JSON.stringify(paramsJo));

      let api_response = await getDeviceOnlineStatusInfo(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        paramsJo
      );

      if (!api_response.ok) {
        console.log("Network response was not ok for fetchDeviceOnlineStatus ");
      } else {
        console.log("request Succes for  fetchDeviceOnlineStatus  ");

        let apires = await api_response.json();

        console.log("Response recieved for online_status:  " + JSON.stringify(apires.deviceStatus[0].online_status));

        setOnlineStatus(apires.deviceStatus[0].online_status); //liveDeviceInfo = {device_uuid:"e7f9348f-9cf4-486a-9aa3-76516893363c",online_status:true}
      }
    } catch (e) {
      console.log("Error in fetchDeviceOnlineStatus :" + e);
    }
  };
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const device = urlParams.get('device');
    setDeviceUUID(device);
    fetchData(device);
  }, []);
  useEffect(() => {
    if (deviceData.agentId && deviceData.agentId != "") {
      console.log("requesting for fetchDeviceOnlineStatus");
      fetchDeviceOnlineStatus();
    }
  }, [deviceData.agentId && deviceData.agentId != ""]);

  const [isCopied, setisCopied] = useState(false);
  const [locationsInfo, setLocationsInfo] = useState([]);

  async function getLocationsList() {
    console.log("[agents]request came getExistingOnly911Locations");
    try {
      let locationsList = await getExistingOnly911Locations(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      if (!locationsList.ok) {
        console.log("got an issue whie");
        throw new Error("Network response was not ok");
      }
      let responseData = await locationsList.json();
      console.log(
        "getExistingOnly911Locations responseData  " + JSON.stringify(responseData)
      );
      if (responseData.status == "success") {
        const finalList = responseData.nineoolocations.map((item) => {
          return {
            value: item.nineoo_loc_id,
            text: item.nineoo_loc_name,
          };
        });
        finalList.unshift({ text: "Select 911 Location", value: "" });
        console.log("911finalList :: " + finalList);
        setLocationsInfo(finalList);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  useEffect(() => {
    getLocationsList();
  }, []);

  const handleNavigation = () => {
    navigate("/pslanding", {
      state: { tab: "tab2" },
    });
  };
  // const handleLocation = (item) => {
  //   console.log("item ::::::::::::::" + item);
  //   // deviceData.profile_id = item;
  //   setValue(`profile_id`, item, {
  //     shouldDirty: true,
  //   });
  // };
  const copyToClipboard = (textContent) => {
    navigator.clipboard
      .writeText(textContent)
    setTooltipText("Copied!");
    setShowTooltip(true)
  };
  const handleMouseLeave = () => {
    setTooltipText("Copy");
  };

  //     .then(() =>{
  //       setisCopied(true);
  //       console.log("Ganesh copied sucess ");
  //     })
  //     .catch(() =>{
  //       console.log("Ganesh copied failed ");
  //     });
  // };

  const section1 = useRef(null);
  const section2 = useRef(null);
  const containerRef = useRef(null);

   const modifytheState = (e, deviceInfo) => {
    e.preventDefault();
    const provisioningMethod = deviceInfo.provisioning_method * 1
    let selMember = provisioningMethod === 1 ? deviceInfo.MacAddress : deviceInfo.deviceUUID;
    const currentIndex = deviceListInfo.findIndex((tmdata) => provisioningMethod === 1 ? tmdata.MacAddress === selMember : tmdata.deviceUUID === selMember);
    const preDeviceInfo = currentIndex > 0 ? deviceListInfo[currentIndex - 1] : null;
    const nextDeviceInfo = currentIndex < deviceListInfo.length - 1 ? deviceListInfo[currentIndex + 1] : null;
    setDeviceInfo(selMember);
    setPreDeviceInfo(preDeviceInfo);
    setNextDeviceInfo(nextDeviceInfo);
    if (provisioningMethod === 2) {
      setDeviceUUID(selMember);
      fetchData(selMember);
    } else {
      const combinedData = {
        selMember,
        preDeviceInfo,
        nextDeviceInfo,
        deviceList: deviceListInfo
      }
      navigate("/ipphoneadd", {
        state: { macAdress: selMember, device: JSON.stringify(combinedData) },
      });
    }
  };

  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={10}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/phonenumbers");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/phonenumbers");
                            }} >
                            <strong>{t("phoneSystem")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a onClick={handleNavigation}>
                            <strong>{t("IPPhonesDevice")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="#">
                            <strong>
                              {deviceData.userName} {deviceData.designation}
                            </strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                      { Object.keys(combineData).length > 0 && <div className="headerbtns">
                        <div className="customtooltip">
                          <MDBBtn
                            size="sm"
                            color="transparent"
                            className={preDeviceInfo != null ? "ms-2 " : "ms-2"}
                            disabled={preDeviceInfo == null || preDeviceInfo === ""}
                            onClick={(e) => modifytheState(e, preDeviceInfo)}
                          >
                            <i className="fa fa-chevron-left"></i>
                          </MDBBtn>
                          {preDeviceInfo != null && preDeviceInfo !== "" && (
                            <span className="tooltiptext">
                              Previous:
                              <br />
                              {preDeviceInfo != null
                                ? preDeviceInfo.PhoneName
                                : ""}
                            </span>
                          )}
                        </div>
                        <div className="customtooltip">
                          <MDBBtn
                            size="sm"
                            color="transparent"
                            className={
                              nextDeviceInfo != null
                                ? "ms-2 active"
                                : "ms-2 active"
                            }
                            disabled={
                              nextDeviceInfo == null || nextDeviceInfo === ""
                            }
                            onClick={(e) =>
                              modifytheState(e, nextDeviceInfo)
                            }
                          >
                            <i className="fa fa-chevron-right"></i>
                          </MDBBtn>
                          {nextDeviceInfo != null && nextDeviceInfo !== "" && (
                            <span className="tooltiptext">
                              Next:
                              <br />
                              {nextDeviceInfo != null
                                ? nextDeviceInfo.PhoneName
                                : ""}
                            </span>
                          )}
                        </div>
                      </div>
                      }
                    </h5>
                  </div>
                  <div className="card-body px-0">
                    <div className="mt-2 d-flex w-100 justify-content-between">
                      {/* <div className="my-2">
                                                <h5 className=""><strong>Nick Leyendecker</strong></h5>
                                                <div>
                                                    <span className="phrecording">IP Phone 2</span>
                                                    <div>
                                                        <span className="phrecording">Manual Device</span>
                                                    </div>
                                                    <div>
                                                        <span className="phrecording">Nicks Algo Paging</span>
                                                    </div>

                                                </div>
                                            </div> */}

                      <div className="pb-3">
                        <h5 className="fw-600">{deviceData.userName}</h5>
                        <p className="mt-1 text-secondary">
                          {deviceData.designation} {/*  IP Phone 2 */}
                        </p>
                        <p className="mt-1 text-secondary">Manual Device</p>
                        <p className="mt-1   text-secondary">
                          {deviceData.phonename} {deviceData.designation}
                        </p>
                      </div>

                      <div className="d-flex justify-content-end ">
                        <div className="d-flex flex-column align-items-center">
                          <strong className="">{t("Online")}</strong>
                          <span
                            className={
                              onlineStatus
                                ? "green-dot mt-2"
                                : "red-dot mt-2"
                            }
                          ></span>
                        </div>
                        <div className="position-relative ms-5">
                          <MDBBtn
                            className="reload-replace-icon"
                            onClick={toggleShow7}
                          >
                            <span className="reload-replace"></span>
                            <span>{t("replaceDevice")}</span>
                          </MDBBtn>
                        </div>
                      </div>
                    </div>

                    <MDBTabs className="mb-3">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                          {t("settings")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "tab1"}>
                        {/* Tab 1 content */}
                        <MDBRow>
                          <MDBCol
                            size="2"
                            md="2"
                            lg="2"
                            sm="12"
                            className="col-sm-100 pr-0 leftTabs"
                          >
                            {/* <MDBTabs className="flex-column">
                              <MDBTabsItem>
                                <MDBTabsLink
                                  href="#general"
                                  onClick={() => handleVerticalClick("tab1")}
                                  active={verticalActive === "tab1"}
                                >
                                  {t("general")}
                                </MDBTabsLink>
                              </MDBTabsItem>
                              <MDBTabsItem>
                                <MDBTabsLink
                                  href="#emergency911"
                                  onClick={() => handleVerticalClick("tab2")}
                                  active={verticalActive === "tab2"}
                                >
                                  {t("emergency911")}
                                </MDBTabsLink>
                              </MDBTabsItem>
                            </MDBTabs> */}

                            <MDBScrollspy container={containerRef} offset={500}>
                              <MDBScrollspyLink targetRef={section1} >{t("general")}</MDBScrollspyLink>
                              <MDBScrollspyLink targetRef={section2} >{t("emergency911")}</MDBScrollspyLink>
                            </MDBScrollspy>
                          </MDBCol>
                          <MDBCol
                            size="12"
                            md="10"
                            sm="12"
                            pr-0
                            className="col-sm-100 pr-0 leftTabContent"
                          >
                            <div className="vtabHeight pr-5">
                              <div id='element' ref={containerRef} className='scrollspy-example'>
                                <div className="w-95">
                                  <section ref={section1} id='section-1'>
                                    <div id="general" class="general-settings">
                                      General
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                      <div>{t("phoneName")}</div>
                                      <div className=" w-40 d-flex">
                                        <input
                                          type="text"
                                          className="form-control w-70 me-2 selectname"
                                          name="phonename"
                                          onKeyDown={(event) => {
                                            if (!/[a-zA-Z0-9 _]/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          {...register("phonename", {
                                            required: {
                                              value: true,
                                              message: "PhoneName canot be empty",
                                            },
                                          })}
                                        />
                                        {errors.PhoneName && (
                                          <p className="text-danger">
                                            {errors.PhoneName.message}
                                          </p>
                                        )}
                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                      <div>{t("username")}</div>
                                      <div className=" w-40 d-flex">
                                        <input
                                          type="text"
                                          className="form-control w-70 me-2 selectname"
                                          readOnly
                                          {...register("sipuser", {
                                            required: { value: true },
                                          })}
                                        />
                                        <img
                                          src={copyIcon}
                                          className="copyIcon "
                                          onClick={() =>
                                            copyToClipboard(deviceData.sipuser)}
                                          alt="Copy Icon"
                                        />


                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                      <div>{t("AuthName")}</div>
                                      <div className=" w-40 d-flex">
                                        <input
                                          type="text"
                                          className="form-control w-70 me-2 selectname"
                                          readOnly
                                          {...register("authenticationName", {
                                            required: { value: true },
                                          })}
                                        />{" "}
                                        <img
                                          src={copyIcon}
                                          className="copyIcon "
                                          onClick={() =>
                                            copyToClipboard(deviceData.authenticationName)}
                                          onMouseLeave={handleMouseLeave}
                                          alt="Copy Icon"
                                        />


                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                      <div>{("Password")}</div>
                                      <div className=" w-40 d-flex position-relative">
                                        <div
                                          className={`password_generation position-absolute w-70 ${showDiv ? "" : "d-none"
                                            }`}
                                        >
                                          <span>Generating password</span>
                                          <div class="loading">
                                            <span class="loading__dot"></span>
                                            <span class="loading__dot"></span>
                                            <span class="loading__dot"></span>
                                          </div>
                                        </div>
                                        <input
                                          type={isFirstImage ? "password" : "text"}
                                          className="form-control w-70 me-2 selectname"
                                          readOnly
                                          {...register("password", {
                                            required: { value: true },
                                          })}
                                        />{" "}
                                        <img
                                          src={copyIcon}
                                          className="copyIcon "
                                          onClick={() =>
                                            copyToClipboard(deviceData.password)}
                                          onMouseLeave={handleMouseLeave}
                                          alt="Copy Icon"
                                        />

                                        <img
                                          src={isFirstImage ? eye : closedEye}
                                          onClick={toggleImage}
                                          className="me-1 copyIcon "
                                        />
                                        <img
                                          src={refresh}
                                          className="copyIcon"
                                          onClick={regeneratePassword}
                                        />
                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                      <div>{t("OutboundProxyServer")}</div>
                                      <div className=" w-40 d-flex">
                                        <input
                                          type="text"
                                          className="form-control w-70 me-2 selectname"
                                          value={deviceData.outboundproxyServer}
                                          readOnly={true}
                                        />{" "}
                                        <img
                                          src={copyIcon}
                                          className="copyIcon "
                                          onClick={() =>
                                            copyToClipboard(deviceData.outboundproxyServer)}
                                          onMouseLeave={handleMouseLeave}
                                          alt="Copy Icon"
                                        />

                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                      <div>{t("OutboundProxyPort")}</div>
                                      <div className=" w-40 d-flex">
                                        <input
                                          type="text"
                                          className="form-control w-70 me-2 selectname"
                                          value={deviceData.proxyPort}
                                          readOnly={true}
                                        />{" "}
                                        <img
                                          src={copyIcon}
                                          className="copyIcon "
                                          onClick={() =>
                                            copyToClipboard(deviceData.proxyPort)}
                                          onMouseLeave={handleMouseLeave}
                                          alt="Copy Icon"
                                        />

                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                      <div>{t("SIPDomain")}</div>
                                      <div className=" w-40 d-flex">
                                        <input
                                          type="text"
                                          className="form-control w-70 me-2 selectname"
                                          readOnly
                                          value={deviceData?.sipdomain}
                                          {...register("sipdomain", {
                                            required: true,
                                          })}
                                        />{" "}
                                        <img
                                          src={copyIcon}
                                          className="copyIcon "
                                          onClick={() =>
                                            copyToClipboard(deviceData.sipdomain)}
                                          onMouseLeave={handleMouseLeave}
                                          alt="Copy Icon"
                                        />

                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                      <div>
                                        <div className="tel-numbers">
                                          {t("SIPTransport")}
                                        </div>
                                        <span className="phrecording">
                                          {t("SIPTransporttxt")}
                                        </span>
                                      </div>

                                      <div className=" w-40 d-flex">
                                        <input
                                          type="text"
                                          className="form-control w-70 me-2 selectname"
                                          value="TCP"
                                          readOnly={true}
                                        />
                                      </div>
                                    </div>
                                  </section>
                                  <div className="routing-border mt-2"></div>
                                  <section ref={section2} id='section-2'>
                                    <div id="emergency911" class="general-settings">
                                      {" "}
                                      {t("emergency911")}
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center my-4">
                                      <div>
                                        {t("select911loc")}
                                      </div>
                                      <div className="d-flex w-40">
                                        {/* <select className="form-control form-select selectname" name="Private">
                                                                            <option value="San Jose">Nick's Home</option>
                                                                            <option value="San Jose">San Jose</option>
                                                                            <option value="San Jose">San Jose</option>
                                                                            <option value="San Jose">San Jose</option>
                                                                        </select> */}
                                        {/* <input
                                      type="text"
                                      className="form-control w-70 me-2 selectname"
                                      {...register("location", {
                                        required: {
                                          value: true,
                                          message: "Location canot be empty",
                                        },
                                      })}
                                    /> */}
                                        <MDBSelect
                                          className="w-70"
                                          // {...register(`profile_id`)}
                                          data={locationsInfo}
                                          search
                                          // searchFn={customSearchFn}
                                          placeholder="Select 911 Location"
                                          value={getValues("profileId")}
                                          onChange={(e) =>
                                            setValue(
                                              "profileId",
                                              parseInt(e?.value),
                                              { shouldDirty: true }
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </div>

                          </MDBCol>
                        </MDBRow>
                      </MDBTabsPane>
                    </MDBTabsContent>
                  </div>
                </div>
              </section>
            </>
          }
        />

        <>
          {showAddDevicePopup && (
            <ShowAddDevicePopup
              replaceDeviceInfo={deviceData}
              onClosePopup={closePopup}
              showDevicePopup={setShowAddDevicePopup}
            />
          )}
          {isDirty && (
            <SaveChanges
              onClose={onCloseChanges}
              onSave={(e) => {
                handleSubmit(onsaveChanges)();
              }}
            />
          )}
        </>

        {isCopied && (
          <MDBAlert
            open
            color="dark"
            autohide
            position="bottom-right"
            delay={2000}
            onClose={() => setisCopied(false)}
          >
            Copied to clipboard
          </MDBAlert>
        )}

        {showTooltip && (
          <MDBAlert
            open
            color="success"
            autohide
            className="alert-center"
            position="bottom-right"
            delay={2000}
            onClose={() => setShowTooltip(false)}
          >
            <MDBIcon far icon="check-circle" color="success" className="me-2" />

            Copied to clipboard
          </MDBAlert>
        )}
        {/* <Footer /> */}
      </>
    </React.Fragment>
  );
}

function ShowAddDevicePopup(props) {
  console.log(props);
  return (
    <>
      <PopupLoader
        title={"Replace Device"}
        content={
          <AddDevices
            replaceDeviceInfo={props.replaceDeviceInfo}
            onClose={(e) => props.onClosePopup()}
          />
        }
        onShow={props.showDevicePopup}
        onClose={props.onClosePopup}
      />
    </>
  );
}
export default ManualDeviceSettings;
